export const PUBLISH_CONTENT_TYPES = {
  BANNER: 'banner',
  TEMPLATE: 'template',
  PARTNERS: 'PARTNERS',
  BRANDS: 'BRANDS',
  DEPARTMENTS: 'DEPARTMENTS',
  PAGES: 'PAGES',
  CATEGORIES: 'CATEGORIES',
  WIDGETS: 'WIDGETS',
  SEO: 'SEO',
  INFORMATION_POLICY: 'INFORMATION_POLICY',
  ADMIN_SETTINGS: 'ADMIN_SETTINGS',
  CONFIG_SETTINGS: 'CONFIG_SETTINGS',
  CAREERS: 'CAREERS',
  CAREER_APPLICATIONS: 'CAREER_APPLICATIONS',
  OUR_TEAM: 'OUR_TEAM',
  PROJECTS: 'PROJECTS',
};
